import { render, staticRenderFns } from "./PrinterInfo.vue?vue&type=template&id=08a9f262&scoped=true&"
import script from "./PrinterInfo.vue?vue&type=script&lang=js&"
export * from "./PrinterInfo.vue?vue&type=script&lang=js&"
import style0 from "./PrinterInfo.vue?vue&type=style&index=0&id=08a9f262&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a9f262",
  null
  
)

export default component.exports